/* =====================================================================
   LIWY — Theme JavaScript
   Scroll animations · Counters · Tabs · Quantity · Header
   ===================================================================== */

(function () {
  'use strict';

  /* ===== SCROLL ANIMATIONS ===== */
  function initScrollAnimations() {
    const els = document.querySelectorAll('.liwy-fade-up');
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('liwy-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.07, rootMargin: '0px 0px -48px 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  /* ===== COUNTER ANIMATION ===== */
  function animateCounter(el) {
    const raw    = el.dataset.target || '0';
    const target = parseFloat(raw);
    const suffix = el.dataset.suffix || '';
    const prefix = el.dataset.prefix || '';
    const duration = 1600;
    const isFloat  = raw.includes('.');
    const start    = performance.now();

    function tick(now) {
      const elapsed  = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased    = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      const val      = target * eased;

      el.textContent = prefix + (isFloat ? val.toFixed(1) : Math.floor(val)) + suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = prefix + target + suffix;
      }
    }

    requestAnimationFrame(tick);
  }

  function initCounters() {
    const counters = document.querySelectorAll('[data-liwy-counter]');
    if (!counters.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach((el) => io.observe(el));
  }

  /* ===== TABS ===== */
  function initTabs() {
    document.querySelectorAll('[data-liwy-tabs]').forEach((group) => {
      const tabs   = group.querySelectorAll('[data-liwy-tab]');
      const panels = group.querySelectorAll('[data-liwy-panel]');

      function activate(tabId) {
        tabs.forEach((t)   => t.classList.toggle('active', t.dataset.liwyTab === tabId));
        panels.forEach((p) => p.classList.toggle('active', p.dataset.liwyPanel === tabId));
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.dataset.liwyTab));
      });

      // Activate first
      if (tabs.length) activate(tabs[0].dataset.liwyTab);
    });
  }

  /* ===== QUANTITY STEPPER ===== */
  function initQuantity() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-liwy-qty]');
      if (!btn) return;

      const wrap  = btn.closest('[data-liwy-qty-wrap]');
      const input = wrap?.querySelector('input[type="number"]');
      if (!input) return;

      const delta = btn.dataset.liwyQty === 'up' ? 1 : -1;
      const min   = parseInt(input.min) || 1;
      const max   = parseInt(input.max) || 999;
      const next  = Math.max(min, Math.min(max, parseInt(input.value) + delta));

      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ===== STICKY HEADER ===== */
  function initHeader() {
    const header = document.querySelector('.header, .header-wrapper');
    if (!header) return;

    let ticking = false;

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            header.style.boxShadow =
              window.scrollY > 20
                ? '0 4px 24px -8px rgba(30, 42, 34, 0.12)'
                : 'none';
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  /* ===== VIDEO AUTOPLAY ON VIEWPORT ===== */
  function initVideos() {
    const videos = document.querySelectorAll('video[data-liwy-autoplay]');
    if (!videos.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.isIntersecting
            ? entry.target.play().catch(() => {})
            : entry.target.pause();
        });
      },
      { threshold: 0.3 }
    );

    videos.forEach((v) => io.observe(v));
  }

  /* ===== SMOOTH ANCHOR SCROLL ===== */
  function initAnchors() {
    // Scroll to next sibling section (hero scroll indicator)
    document.querySelectorAll('[data-liwy-scroll-next]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var section = link.closest('section, [class*="-hero"], .liwy-hero');
        var next = section ? section.nextElementSibling : null;
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Generic hash anchor scroll
    document.querySelectorAll('a[href^="#"]:not([data-liwy-scroll-next])').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ===== VARIANT SELECTION ===== */
  function initVariantHighlight() {
    document.querySelectorAll('.liwy-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.liwy-variant-group');
        group.querySelectorAll('.liwy-variant-btn').forEach(function (b) {
          b.classList.remove('selected');
        });
        btn.classList.add('selected');

        // Find the product section with variant data
        var productSection = btn.closest('[data-liwy-product]');
        if (!productSection) return;

        var dataEl = document.getElementById('liwy-product-data-' + productSection.dataset.liwyProduct);
        if (!dataEl) return;

        var data;
        try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

        // Collect currently selected option value from each group
        var selectedValues = [];
        productSection.querySelectorAll('.liwy-variant-group').forEach(function (grp) {
          var sel = grp.querySelector('.liwy-variant-btn.selected');
          if (sel) selectedValues.push(sel.dataset.value);
        });

        // Find the variant whose options match all selected values
        var match = data.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selectedValues[i]; });
        });
        if (!match) return;

        // Update the hidden variant ID input in the form
        var form = productSection.querySelector('form');
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = match.id;
        }

        // Update ATC button disabled state and label
        var atcBtn = productSection.querySelector('[type="submit"]');
        if (atcBtn) {
          atcBtn.disabled = !match.available;
          var label = match.available
            ? (atcBtn.dataset.atc || 'Lägg i varukorg')
            : (atcBtn.dataset.soldout || 'Tillfälligt slut');
          // Update only the first text node so any inner SVG is preserved
          for (var i = 0; i < atcBtn.childNodes.length; i++) {
            if (atcBtn.childNodes[i].nodeType === 3) {
              atcBtn.childNodes[i].textContent = label;
              break;
            }
          }
        }
      });
    });
  }

  /* ===== MARQUEE PAUSE ON HOVER ===== */
  function initMarquee() {
    document.querySelectorAll('[data-liwy-marquee]').forEach((el) => {
      el.addEventListener('mouseenter', () => (el.style.animationPlayState = 'paused'));
      el.addEventListener('mouseleave', () => (el.style.animationPlayState = 'running'));
    });
  }

  /* ===== PRODUCT IMAGE GALLERY ===== */
  function initProductGallery() {
    document.querySelectorAll('[data-liwy-gallery]').forEach(function (gallery) {
      var track   = gallery.querySelector('.liwy-prod-gallery__track');
      var dots    = gallery.querySelectorAll('.liwy-prod-gallery__dot');
      var prevBtn = gallery.querySelector('[data-liwy-prev]');
      var nextBtn = gallery.querySelector('[data-liwy-next]');
      if (!track) return;

      function slideCount() {
        return gallery.querySelectorAll('.liwy-prod-gallery__slide').length;
      }

      function currentIndex() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }

      function scrollToIndex(idx) {
        var count = slideCount();
        idx = Math.max(0, Math.min(count - 1, idx));
        track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
      }

      function updateDots() {
        var index = currentIndex();
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === index);
        });
      }

      track.addEventListener('scroll', updateDots, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          scrollToIndex(parseInt(dot.dataset.index, 10));
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(currentIndex() + 1); });
    });
  }

  /* ===== AJAX CART — opens Dawn's cart drawer ===== */
  function initAjaxCart() {
    ['liwy-sport-form', 'liwy-everyday-form', 'liwy-odour-form'].forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        var originalHTML = btn ? btn.innerHTML : '';
        if (btn) btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add failed');
            // Use Dawn's Section Rendering API to get fresh cart drawer HTML
            return fetch('/?sections=cart-drawer,cart-icon-bubble');
          })
          .then(function (res) { return res.json(); })
          .then(function (sections) {
            var p = new DOMParser();

            // Refresh the cart icon count badge
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl && sections['cart-icon-bubble']) {
              var newBubble = p.parseFromString(sections['cart-icon-bubble'], 'text/html')
                               .getElementById('cart-icon-bubble');
              if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
            }

            // Update cart drawer contents without breaking the web component
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              if (sections['cart-drawer']) {
                var newDoc = p.parseFromString(sections['cart-drawer'], 'text/html');
                var newDrawer = newDoc.querySelector('cart-drawer');
                if (newDrawer) {
                  // Update specific inner containers — preserves the web component's event listeners
                  var selectors = [
                    'cart-drawer-items',
                    '#CartDrawer-CartItems',
                    '#CartDrawer-Footer',
                    '.cart-drawer__footer',
                    '.drawer__inner-empty',
                  ];
                  var updated = false;
                  selectors.forEach(function (sel) {
                    var existing = drawer.querySelector(sel);
                    var fresh    = newDrawer.querySelector(sel);
                    if (existing && fresh) {
                      existing.innerHTML = fresh.innerHTML;
                      updated = true;
                    }
                  });
                  // Sync is-empty state
                  drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
                }
              }
              drawer.open();
            } else {
              // Fallback: redirect to cart page
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            // Fallback: submit normally
            form.submit();
          })
          .finally(function () {
            if (btn) {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
            }
          });
      });
    });
  }

  /* ===== INIT ===== */
  function init() {
    initScrollAnimations();
    initCounters();
    initTabs();
    initQuantity();
    initHeader();
    initVideos();
    initAnchors();
    initVariantHighlight();
    initMarquee();
    initProductGallery();
    initAjaxCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
